export default {"src":"/_next/static/media/twoPeopleTalkLegal_40.694d2028.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};